/* eslint-disable no-undef */
import axios from "axios";


export const CONFIG_API = axios.create({
    baseURL: process.env.VUE_APP_CONFIG_SERVER,
    timeout: 30000,
});

export const IMPORT_API = axios.create({
    baseURL:  process.env.VUE_APP_CONFIG_SERVER,
    timeout: 1200000,
});
export const DATA_API = axios.create({
    baseURL: process.env.VUE_APP_DATA_SERVER,
    timeout: 30000,
});

export const MOCK_API = axios.create({
    baseURL: process.env.VUE_APP_MOCK_API,
    timeout: 30000,
});

